
export class Bullets {
    constructor(bulletsDomEl ) {

        const moduleEl = bulletsDomEl;

        const bullets = moduleEl.querySelectorAll(".bullet-pointer");
        const container = moduleEl.querySelector('.bullets-mobile-container');
        const heading = container.querySelector('.bullet-content__header');
        const txt = container.querySelector('.bullet-content__text');

        if (bullets.length === 0) return;
        

        [].forEach.call(bullets, bullet => {
        
            bullet.addEventListener(
                'click', (e) => {         
                    e.preventDefault();            
                    const activeBullet = moduleEl.querySelector('.bullet-pointer.active')              
                    const bulletContent = bullet.parentNode;
                    const bulletHeading = bulletContent.querySelector('H3').textContent
                    const bulletTxt = bulletContent.querySelector('DIV').textContent   

                    if (!container.classList.contains('active'))
                        container.classList.add('active')
                    
                    if(activeBullet)
                        activeBullet.classList.remove('active')

                    if (!bullet.classList.contains('active')) 
                        bullet.classList.add('active')                                     
                        
                    heading.textContent = bulletHeading;
                    txt.textContent = bulletTxt;
                }
            )
        });

    }

}

class BulletsElList {
    constructor() {}
    init(){
        this.bulletsDomElements = document.querySelectorAll('[data-marketingwifi]');
        this.bulletsArr = [];
        [].forEach.call(this.bulletsDomElements, (el) => {
            this.bulletsArr.push(new Bullets(el)); 
        }); 
    }

}

const showBulletInfo = new BulletsElList();
export { showBulletInfo }


